@if (currentUser$ | async; as currentUser) {
  <div class="user" (click)="utils.goToEmployeePage(currentUser.id)">
    <div class="user__content">
      <app-user-data
        [imgSize]="UserDataImgSize.s"
        [imgSrc]="currentUser.avatar ? currentUser.avatar.previewNormal : ''"
        [fullName]="currentUser | getFullName"
        [position]="currentUser.userPosition?.name"
      ></app-user-data>
      <app-image [img]="'./assets/images/icons-svg/arrow-right.svg'"></app-image>
    </div>
  </div>
}
